<!--
   Created by qing on 2020/11/9
   Des: 表单数据详情
-->
<template>
  <div class="form-data-detail" v-wechat-title="title">
    <template v-if="!errorInfo.code">
      <FormDataDetail
        v-if="viewId === 'dataHandle'"
        ref="formDataDetail"
        :viewType="3"
        :appId="appId"
        :formId="formId">
      </FormDataDetail>
      <FormViewDataDetail
        ref="formViewDataDetail"
        :viewType="1"
        :appId="appId"
        :formId="formId">
      </FormViewDataDetail>
    </template>
    <div v-else class="error-page">
      <img src="../../../assets/images/empty.png" alt="">
      <p>{{errorInfo.info}}({{errorInfo.code}})</p>
    </div>
  </div>
</template>

<script>
  import FormDataDetail from "../../component/FormDataDetail";
  import FormViewDataDetail from "../../component/FormViewDataDetail";
  import {SUCCESS} from "../../store/types";
  export default {
    data() {
      return {
        title: '',
        dataValue: null,
        appId: '',
        formId: '',
        viewId: 'dataHandle',
        errorInfo: {
          code: '',
          info: ''
        }
      }
    },
    components: {
      FormDataDetail,
      FormViewDataDetail
    },
    async created() {

      const pageConfig = await this.$store.dispatch('actionSpacePageConfigDetail', {
        spaceId: this.$route.params.spaceId,
        pageConfigId: this.$route.params.pageConfigId
      }).catch(console.error)

      this.title = pageConfig.pageTitle
      this.$store.dispatch('setPageTitle', this.title)
      const pageDetailConfig = pageConfig.pageConfigDetail || {}

      this.appId = pageDetailConfig.appId
      this.formId = pageDetailConfig.formId
      this.viewId = pageDetailConfig.viewId || 'dataHandle'

      this.$store.commit('UPDATE__FORM_ID', this.formId)
      this.$store.commit('UPDATE__APP_ID', this.appId)

      const {
        companyId,
        userId
      } = this.$store.state
      const viewList = await this.$store.dispatch('actionFetchFormViewList', {
        userId,
        companyId,
        appId: this.appId,
        formId: this.formId
      }).catch(console.error)

      if (viewList) {
        const hasViewPer = viewList.some(item => item.viewId === this.viewId)
        if (!hasViewPer) {
          this.errorInfo.code = -1
          this.errorInfo.info = '您暂时没有查看该视图详情权限，请联系管理员'
        }
      }

      this.$store.dispatch('actionSpaceApplyData', {
        ...pageDetailConfig
      }).then(({status, resultObject, info}) => {
        if (status === SUCCESS) {
          this.dataValue = resultObject

          if (this.viewId === 'dataHandle') {
            if (this.$refs.formDataDetail) {
              this.$refs.formDataDetail.existValueOpen({
                values: this.dataValue,
                instanceId: this.dataValue['instanceId'],
                hasEdit: pageDetailConfig.allowEdit
              })
            }
          } else {
            if (this.$refs.formViewDataDetail) {
              this.$refs.formViewDataDetail.existValueOpen({
                values: this.dataValue,
                viewId: this.viewId,
                instanceId: this.dataValue['instanceId'],
                stepId: this.dataValue['stepId'],
                hasEdit: pageDetailConfig.allowEdit
              })
            }
          }
        } else {
          this.errorInfo.code = status
          this.errorInfo.info = info
        }

      }).catch(console.error)
    },
    methods: {}
  }
</script>

<style lang="less">

  .form-data-detail {
    height: 100%;
  }
</style>